import { defineStore } from 'pinia'
import api from '@/api/global.js'
import { asyncRoutes } from '@/router/index'
// import { mockMenu } from '@/router/mockMenu'
import { message } from 'ant-design-vue'

const useUserStore = defineStore('userStore', {
  state: () => ({
    peerid: '', // 可理解为token
    qrcodeid: '', // 登录二维码codeId
    sessionid: '',
    projectCount: {}, // 当前用户总项目数量和各项目数量
    userInfo: {} // 用户信息
  }),
  persist: {
    enabled: true,
    strategies: [
      {
        paths: ['peerid', 'qrcodeid', 'sessionid', 'projectCount', 'userInfo'],
        storage: localStorage,
        key: 'userStore',
        condition: () => this.loginType === 'normal'
      }
    ]
  },
  getters: {
    // 路由缓存
    keepAliveRoutes: (state) => {
      let cacheRouter = []
      let deep = (asyncRoutes) => {
        asyncRoutes.forEach((item) => {
          if (item.meta?.keepAlive && item.name) {
            cacheRouter.push(item.name)
          }
          if (item.children && item.children.length) {
            deep(item.children)
          }
        })
      }
      deep(asyncRoutes)
      return cacheRouter
    }
  },
  actions: {
    setStoreUserInfo(payload) {
      this.userInfo = payload
    },
    setStoreQrcodeid(payload) {
      this.qrcodeid = payload
    },
    setStoreSessionid(payload) {
      this.sessionid = payload
    },
    setStoreProjectCount(payload) {
      this.projectCount = payload
    },
    // 退出登录后清空数据
    emptyUserInfo() {
      this.$reset()
    },
    // 退出登录
    async loginOut() {
      this.emptyUserInfo()
      setTimeout(() => {
        location.replace('/')
      }, 300)
    },
    // 获取peerid值
    async getPeerid() {
      const res = await api.peerid({ imei: '', clienttype: 'web' })
      this.peerid = res.peerid
    },
    // 获取qrcodeid值
    async getQrcodeid() {
      const res = await api.qrcodePic({ imei: '', clienttype: 'web' })
      this.qrcodeid = res.qrcodeid
    },
    // 获取用户信息
    async getUserInfo() {
      // const res = await api.userInfo()
      // this.setStoreUserInfo(res)
      // this.setStoreMenu(res.menu_resources)
    }
  }
})

export default useUserStore
